import { CALENDAR_MODE } from '@/ux-common/components/calendar/calendar.types';

import {
  isValidMultipleValue,
  isValidRangeValue,
  isValidSingleValue,
} from './calendar-picker.utils';

/**
 * Mode-keyed lookup of the validator that gates the Apply button per
 * selection mode. Keeps the validator wiring co-located with the mode
 * constants so adding a new mode only requires touching one map.
 */
export const MODE_VALIDATORS = {
  [CALENDAR_MODE.SINGLE]: isValidSingleValue,
  [CALENDAR_MODE.RANGE]: isValidRangeValue,
  [CALENDAR_MODE.MULTIPLE]: isValidMultipleValue,
} as const;
